<template>
    <el-dialog
        title="扫二维码录音"
        :visible.sync="dialogVisible"
        :append-to-body="true"
        :close-on-click-modal="false"
        width="400px"
        :before-close="handleClose">
            <element-form
                :form.sync="form"
                @onAttr="onAttr"
            />
            <div v-if="isMa2 && onlyString" class="ma2-box">
                <p class="warn">请使用微信扫一扫下方的二维码，录音完成后上传</p>
                <div v-if="dialogVisible" id="qrcode" ref="qrcode"></div>
            </div>
    </el-dialog>
</template>

<script>
    import BMF from 'browser-md5-file'
    import QRCode from 'qrcodejs2'
    import {upLoad, getFileStream} from "../../../../utils/upload";
    import * as commonServer from '../../../../api/common'
    import * as resultServer from '../../../../api/result'
    export default {
        name: "ma2",
        props: {
            url: String,
            visible: Boolean,
            categoryId: [String, Number]
        },
        computed: {
            getResourceCategoryTree(){
                return this.$store.getters.isPlat?'getResourceCategoryShopTree':'getResourceCategoryTree'
            },
            catalogId(){
                const categoryIdIndex = this.$utils.getIndexByAttr({attr:'categoryId', data: this.form})
                return this.form[categoryIdIndex].value
            },
            isPlat () {
                return this.$store.state.isShop
            },
            addResource(){
                return this.isPlat?'addResourceShop':'addResource'
            },
            getResourceDetail(){
                return this.isPlat?'getResourceShopDetail':'getResourceDetail'
            },
        },
        watch: {
            categoryId(vl){this.newCatalogId = vl},
            newCatalogId(vl){this.$emit('update:categoryId', vl)},
            visible(vl){
                this.dialogVisible = vl
                this.$nextTick(()=>{
                    // this.qrcode()
                })
            },
            dialogVisible(vl){
                this.$emit('update:visible', vl)
            },
            onlyString(vl){
                if(vl){
                    this.isMa2 = false
                    this.isMa2 = true
                    this.$nextTick(()=>{
                        this.qrcode()
                    })
                }
            }
        },
        created(){
            this.init()
            // this.$nextTick(()=>{
            //     this.qrcode()
            // })
        },
        data(){
            return {
                newCatalogId: this.catalogId,
                dialogVisible: this.visible,
                onlyString: '', // 获取音频凭证
                isValidating: false, // 是否正在校验mp3文件是否真实存在
                isMa2: true,
                type: 'audio',
                form: [
                    {
                        attr: 'categoryId',
                        "name": "目录选择",
                        "value": "",
                        "type": "Select",
                        "props": {
                            "placeholder": "请输入",
                            "rules": {
                                "required": false,
                                "message": "请输入",
                                "target": "blur"
                            }
                        },
                        "options": [
                        ]
                    },
                    {
                        attr: 'name',
                        "name": "文件名称",
                        "value": "",
                        "type": "Input",
                        "props": {
                            "style": "width:194px;",
                            "placeholder": "请输入",
                            "rules": {
                                "required": false,
                                "message": "请输入",
                                "target": "blur"
                            }
                        },
                        "options": [
                        ]
                    }
                ],
                fnRecord: null, // 轮询事件
                timeout: 60 * 15 // 超时15分钟，自动关闭
            }
        },
        methods: {
            async init(){
                // 获取目录列表
                const res = await commonServer.default[this.getResourceCategoryTree]({
                    clientsId: this.$store.state.initConfig.school_id,
                    sort: this.type
                })
                let data = res.data
                console.log('upload->form==>', res)
                let index = this.$utils.getIndexByAttr({attr:'categoryId', data: this.form})
                this.form[index].options = this.$utils.FormatData(data)
                if(data && data.length>0){
                    this.form[index].value = `${data[0].id}`
                } else {
                    this.loopWeixinBack()
                }
            },
            qrcode () {
                console.log('dom==>', document.getElementById('qrcode'), this.onlyString)
                document.getElementById('qrcode').innerHTML = ''
                if(this.url && this.onlyString) {
                    new QRCode('qrcode', {
                        correctLevel: 3,
                        width: 300, // 设置宽度，单位像素
                        height: 300, // 设置高度，单位像素
                        text: `${this.url}&audioCatalogId=${this.catalogId}&item=${this.onlyString}`   // 设置二维码内容或跳转地址
                    })
                }
            },
            handleClose(){
                clearInterval(this.fnRecord)
                this.dialogVisible = false
                const categoryIdIndex = this.$utils.getIndexByAttr({attr:'categoryId', data: this.form})
                this.form[categoryIdIndex].value = ''
            },
            async onAttr(obj){
                console.log('attr==>', obj)
                switch (obj.attr) {
                    case 'categoryId': {
                        const categoryIdIndex = this.$utils.getIndexByAttr({attr:'categoryId', data: this.form})
                        this.newCatalogId = this.form[categoryIdIndex].value
                        this.loopWeixinBack()
                        break
                    }
                    default:
                }
            },
            // 轮询
            async loopWeixinBack () {
                // 获取音频上传唯一标识
                const res = await resultServer.getAudioRecord({
                    clientsId: `${this.$store.state.initConfig.school_id}` === '-1' ? 0 : this.$store.state.initConfig.school_id
                })
                console.log('获取==>', res)
                this.onlyString = res.item
                // 轮询访问当前是否已经上传好了
                this.getLastRecord()
            },
            getLastRecord () {
                clearInterval(this.fnRecord)
                let time = 0
                this.fnRecord = setInterval(async ()=>{
                    console.log('时间==>', time, this.timeout)
                    time += 2
                    if(this.isValidating){
                        return false
                    }
                    if(time > this.timeout){
                        this.$message.error('等待超时')
                        this.time = 0
                        this.dialogVisible = false
                        clearInterval(this.fnRecord)
                        return false
                    }
                    const res = await resultServer.getAudioRecordUrl({item: this.onlyString})
                    console.log('录音信息==>', res)
                    if(res.data){
                        this.loadAudio('https://'+res.data)
                    }
                }, 2000)
            },

            // 判断音频是否存在
            loadAudio(path) {
                this.isValidating = true
                const self = this;
                const audio = document.createElement('audio'); // 生成一个audio元素
                audio.src = `${path}?v=${Math.random()}`; // 音乐的路径
                audio.addEventListener('canplay', () => {
                    // 当文件存在时，将文件存到服务端
                    // 1.远端地址转成文件流上传
                    // setTimeout(()=>{
                        let nameIndex = this.$utils.getIndexByAttr({ attr: 'name', data: this.form})
                        let name = this.form[nameIndex].value
                        self.uploadAudio({url: path, type: 'wx', name, callback: (newPath)=>{
                                // 获取成功
                                self.$message.success('上传成功')
                                self.time = 0
                                self.dialogVisible = false
                                clearInterval(self.fnRecord)

                                self.$emit('onMa2', {url: newPath, name})

                                // 刷新父级
                                self.$emit('onFlash')
                            }})
                    // }, 200)
                });
                audio.onerror = function () {
                    self.isValidating = false
                };
            },
            // 将远端地址转成文件流上传
            uploadAudio({url, type, name, callback}) {
                // 将合成音频上传至音频素材
                // 1.将远端地址转成文件流
                // 2.将文件流上传到腾讯云
                // 3.上传合成音频到素材
                getFileStream({url, name, callback: (blob)=>{
                        const bmf = new BMF()
                        bmf.md5(blob, (err, md5)=>{
                            upLoad({isPlat: this.isShop, fileName: `${md5}.mp3`, file: blob, callback: async url=>{
                                    let newName = type === 'wx'?'微信':'合成'+'音频' + md5.slice(0,3)
                                    if(name) {
                                        newName = name
                                    }
                                    // 上传音频文件到素材列表
                                    let newUrl = this.$utils.getHtmlMd5(url)
                                    const remotepath = url.split('.com/')[1]
                                    let obj = {
                                        clientsId: this.$store.state.initConfig.school_id,
                                        sort: 'audio',
                                        name: newName,
                                        alias: '',
                                        attributes: {
                                            cover: url,
                                            remotepath,
                                            md5: newUrl.indexOf('.') > -1?newUrl.split('.')[0] : newUrl
                                        }
                                    }
                                    if(`${this.categoryId}` !== `0`) obj.categoryId = this.categoryId

                                    const res = await commonServer.default[this.addResource](obj)
                                    if (`${res.status_code}` === '200') {
                                        // 根据文件id 获取文件路径
                                        if(res.data.id){
                                            const detail = await commonServer.default[this.getResourceDetail]({
                                                id: res.data.id,
                                                clientsId: this.$store.state.initConfig.school_id,
                                            })
                                            try {
                                                callback && callback(detail.data.attributes.resources.url)
                                            } catch (e) {
                                                console.log('获取音频地址失败==>')
                                            }
                                        }
                                    } else {
                                        this.$message.error('上传失败')
                                    }

                                }})
                        })

                    }})
            }
        }
    }
</script>

<style lang="scss" scoped>
    .ma2-box{
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .warn{
            margin-bottom: 20px;
        }
    }
</style>
